import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
import { API } from '@service';

import { Button, Input, Modal, Skeleton, Upload } from 'antd';
import { Loading } from '@components';
import FullScreenButton from '@components/fullScreenButton';
import alert from '@components/alert';
// import { USER_ROLE_MODEL } from '@model';
import useObjectUrl from '@hooks/useObjectURL';
import { FixedRatioSectionWrapper } from '@components/fixedRatioContainer';
import { filterXSS } from 'xss';
import {
  getImageUploadClientError,
  IMAGE_UPLOAD_ACCEPT,
} from '@utils/imageUploadValidation';

const ImageDisplay = (props) => {
  const {
    identifier,
    link,
    setLink,
    changeOrderPropsValue,
    section,
    sectionOrder,
    onSortEnd,
    title,
  } = props;

  // const projectId = useSelector((state) => state.common.currentId);
  // const isClient = useSelector(
  //   ({ login }) => login.userInfo.role === USER_ROLE_MODEL.CLIENT,
  // );
  const [hasUploaded, setHasUploaded] = useState(Boolean(link));

  const [image, setImage] = useState();
  const [imageName, setImageName] = useState();
  const [uploadedImage, setUploadedImage] = useState();
  const [uploadedImageName, setUploadedImageName] = useState();

  const [showUpload, setShowUpload] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);
  const [imageVisible, setImageVisible] = useState(false);
  const [, setExpand] = useState(false);
  const [titleError, setTitleError] = useState(false);
  const [titleRepeat, setTitleRepeat] = useState(false);
  const [extValid, setExtValid] = useState(true);
  const [clientImageError, setClientImageError] = useState(null);
  const objectURL = useObjectUrl(uploadedImage);

  const validateFile = (file) => {
    const clientErr = getImageUploadClientError(file);
    if (clientErr) {
      alert.error(clientErr);
      setClientImageError(clientErr);
      setExtValid(false);
      return false;
    }
    setClientImageError(null);
    setExtValid(true);
    const fileReader = new FileReader();
    fileReader.onload = () => {
      setImage(file);
      setImageName(file.name);
    };
    fileReader.readAsBinaryString(file);
    return false;
  };

  const restoreData = () => {
    setImage(uploadedImage);
    setImageName(uploadedImageName);
  };

  const handleDelete = () => {
    setBtnLoading(true);
    setImage(null);
    setImageName(null);
    setBtnLoading(false);
  };

  const handleCancel = () => {
    setBtnLoading(true);
    if (hasUploaded) {
      restoreData();
    } else {
      handleDelete();
    }
    setShowUpload(false);
    setBtnLoading(false);
    setTitleError(false);
    setExtValid(true);
    setClientImageError(null);
  };

  const handleUpload = async () => {
    let orders = changeOrderPropsValue(
      sectionOrder,
      section.identifier,
      'titleName',
      document.getElementById('title-img').value,
    );
    setBtnLoading(true);
    if (!image) {
      alert.error('Please choose a file to upload');
      setBtnLoading(false);
      return;
    }
    if (image instanceof File) {
      const clientErr = getImageUploadClientError(image);
      if (clientErr) {
        alert.error(clientErr);
        setBtnLoading(false);
        return;
      }
    }
    const formData = new FormData();
    formData.append('file', image);
    const res = await API.uploadIMG(formData);
    setLink(res.path);
    orders = changeOrderPropsValue(
      orders,
      section.identifier,
      'link',
      res.path,
    );
    onSortEnd(orders);
    setUploadedImage(image);
    setUploadedImageName(imageName);
    setHasUploaded(true);
    setImageVisible(true);
    setShowUpload(false);
    setBtnLoading(false);
  };

  const handleSave = async () => {
    let orders = changeOrderPropsValue(
      sectionOrder,
      section.identifier,
      'titleName',
      document.getElementById('title-img').value,
    );
    setBtnLoading(true);
    if (image === null) {
      await API.deleteIMG(link);
      setLink(null);
      orders = changeOrderPropsValue(orders, section.identifier, 'link', null);
      setUploadedImage(null);
      setUploadedImageName(null);
      setHasUploaded(false);
      setImageVisible(false);
    } else if (image !== uploadedImage) {
      if (image instanceof File) {
        const clientErr = getImageUploadClientError(image);
        if (clientErr) {
          alert.error(clientErr);
          setBtnLoading(false);
          return;
        }
      }
      const formData = new FormData();
      formData.append('file', image);
      formData.append('fileName', link);
      const res = await API.updateIMG(formData);
      setLink(res.path);
      orders = changeOrderPropsValue(
        orders,
        section.identifier,
        'link',
        res.path,
      );
      setUploadedImage(image);
      setUploadedImageName(imageName);
      setImageVisible(true);
    }
    onSortEnd(orders);
    setShowUpload(false);
    setBtnLoading(false);
  };

  useEffect(() => {
    if (!hasUploaded && link && link !== '') {
      setHasUploaded(true);
      return;
    }
    if (hasUploaded && link) {
      (async () => {
        const data = await API.downloadIMG(link);
        setUploadedImage(data);
        setUploadedImageName(link);
        setImage(data);
        setImageName(link);
      })();
      setImageVisible(true);
    } else {
      setBtnLoading(true);
      setImage(null);
      setImageName(null);
      setBtnLoading(false);
      setHasUploaded(false);
    }
  }, [link, hasUploaded]);

  const renderFooter = (
    <div>
      <Button onClick={handleCancel} loading={btnLoading}>
        Cancel
      </Button>
      <Button
        onClick={hasUploaded ? handleSave : handleUpload}
        loading={btnLoading}
        type="primary"
        disabled={(!hasUploaded && !image) || titleError || !extValid}
      >
        {hasUploaded ? 'Save' : 'Upload'}
      </Button>
    </div>
  );

  const titleWarning = (
    <div className="title-warning">
      {titleRepeat
        ? '* The name already exists, please enter another name.'
        : '* The title is required'}
    </div>
  );

  const checkInput = (e) => {
    let isRepeat, isBlank;
    isRepeat = isBlank = false;
    sectionOrder.forEach((item) => {
      if (e.target.value === '') {
        isBlank = true;
      } else if (
        item.identifier !== section.identifier &&
        item.titleName === e.target.value
      ) {
        isRepeat = true;
      }
    });
    setTitleRepeat(isRepeat);
    setTitleError(isRepeat || isBlank);
  };

  return (
    <>
      {hasUploaded ? (
        <div className="powerbi-title-link">
          <div className="left">
            <span className="title">{title}</span>
          </div>
          <div className="right">
            <FullScreenButton
              elemId={`#fullscreen-${identifier}`}
              onToggleFullScreen={() => setExpand((e) => !e)}
            />
          </div>
        </div>
      ) : (
        <>
          <span className="powerbi-title">{title}</span>
          <Button
            type="primary"
            style={{
              fontWeight: 500,
              marginLeft: 10,
            }}
            onClick={() => {
              setShowUpload(true);
            }}
            className="role-control"
          >
            {!hasUploaded ? 'Upload Image' : 'Edit Image'}
          </Button>
        </>
      )}
      {hasUploaded && link && (
        <FixedRatioSectionWrapper
          ratio={section.ratio}
          className="image-fullscreen-div"
          id={`fullscreen-${identifier}`}
          imgChild
        >
          {imageVisible && uploadedImage ? (
            <img src={filterXSS(objectURL)} alt="not-found" />
          ) : (
            <Loading style={{ textAlign: 'center', marginTop: '10%' }} />
          )}
        </FixedRatioSectionWrapper>
      )}
      <Modal
        className="upload-modal upload-img"
        title={!hasUploaded ? 'Upload IMG' : 'Edit IMG'}
        footer={renderFooter}
        visible={showUpload}
        onCancel={handleCancel}
        destroyOnClose
      >
        <div className="modal-name-label image">Section Name</div>
        <Input
          id="title-img"
          defaultValue={title}
          maxLength={100}
          onChange={checkInput}
          autoComplete="off"
        />
        {titleError && titleWarning}
        <div className="file-upload-label">IMG File</div>
        <Upload.Dragger
          showUploadList={false}
          accept={IMAGE_UPLOAD_ACCEPT}
          maxCount={1}
          beforeUpload={(file) => validateFile(file)}
        >
          <span>Choose your image</span>
          <div className="upload-tips">
            <span>
              <br />
              1. Allowable file types: JPEG, PNG, GIF, WebP, BMP, ICO, and SVG.
              <br />
              2. Maximum file size: 20 MB.
              <br />
              3. Image will automatically scale to fit report ratio size.
              <br />
              4. Large images may result in slower page loading times for all
              users. Please be mindful of file size.
            </span>
          </div>
        </Upload.Dragger>
        {imageName && (
          <>
            <div className="file-list">
              <Skeleton paragraph={false} active loading={false}>
                {imageName.substr(
                  imageName.lastIndexOf('_') + 1,
                  imageName.length,
                )}
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <span
                    className="appkiticon icon-circle-delete-fill"
                    onClick={handleDelete}
                  />
                </div>
              </Skeleton>
            </div>
            {!extValid && clientImageError ? (
              <div className="active-color">{clientImageError}</div>
            ) : null}
          </>
        )}
      </Modal>
    </>
  );
};

export default ImageDisplay;
